module.exports = __webpack_public_path__ + "static/media/emina.91dd1b76.png";